import { useEffect, useState } from "react";

export const useDebounceValue = (value: any, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState<any>(value);

  useEffect(() => {
    const t: NodeJS.Timeout = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(t);
  }, [value, delay]);

  return debouncedValue;
};
